<template>
  <div>
    <div class="center verticalPadding marginTop">
      <strong class="titles">
        <template v-for="step in steps">
          <span
            :class="stepNum === step.index ? 'selectedDot' : 'unselectedDot'"
            :key="'tag-' + step.index"
          >
            {{ step.tag }}
          </span>
          <strong
            v-if="steps[steps.length - 1] !== step"
            :key="'>-' + step.index"
          >
            >
          </strong>
        </template>
      </strong>
    </div>
    <div class="marginLR">
      <DatosOperacion
        ref="datosOperacion"
        v-show="stepNum === 1"
        :datosOperacion="operacion"
      />
      <DatosDeudorOAcreedor
        ref="datosAcreedor"
        v-show="stepNum === 2"
        :entidades="entidadesAcreedor"
        :paid="false"
        :creditorOrDebtorData="operacion.datosAcreedor"
        :defaultLanguage="defaultLanguage"
        :isDebtor="false"
        :actOnOwnName="actOnOwnName"
        @address:input="loadingCTIAddressNormalization = $event"
        @address:dialog="CTIAddressDialog = $event"
      />
      <DatosDeudorOAcreedor
        ref="datosDeudor"
        v-show="stepNum === 3"
        :entidades="entidadesDeudor"
        :paid="false"
        :creditorOrDebtorData="operacion.datosDeudor"
        :defaultLanguage="defaultLanguage"
        :isDebtor="true"
        @address:input="loadingCTIAddressNormalization = $event"
        @address:dialog="CTIAddressDialog = $event"
      />
      <ResumenOperacion
        ref="resumenOperacion"
        v-if="stepNum === 4"
        :datosOperacion="operacion"
        :erroresAltaOperacion="erroresAltaOperacion"
      />
    </div>

    <div class="openTopWhitePanel marginLR">
      <div class="grid">
        <div class="col-3">
          <div>
            <Button
              @click.prevent="backward()"
              :label="
                stepNum === 1
                  ? this.$t('altaImpago.botones.inicio')
                  : this.$t('altaImpago.botones.atras')
              "
              class="bigBlueButton"
              icon="pi pi-angle-left"
              iconPos="left"
              :disabled="loadingCTIAddressNormalization"
            />
          </div>
        </div>

        <div class="col-3 col-offset-6">
          <div>
            <Button
              @click.prevent="forward()"
              :label="
                stepNum !== steps.length
                  ? this.$t('altaImpago.botones.siguiente')
                  : this.$t('altaImpago.botones.finalizar')
              "
              class="bigBlueButton rightAlign"
              icon="pi pi-angle-right"
              iconPos="right"
              :disabled="loadingCTIAddressNormalization || loadingInsertOp || CTIAddressDialog"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="layout-content">
      <Toast />
    </div>
  </div>
</template>


<script>
import DatosDeudorOAcreedor from "@/components/portal-cliente/DatosDeudorOAcreedor.vue";
import { MUTATION_ALTA_RECLAMACION } from "@/graphQLQueries/ReclamacionQueries";
import RoutesMixin from "@/utils/routes";
import StringsMixin from "@/utils/strings";
import { TIPOS_USUARIOS } from "@/resources/constants";
import MessagesMixin from "@/utils/messages";
import DatosOperacion from "./DatosOperacion.vue";
import ResumenOperacion from "./ResumenOperacion.vue";
import CarterasMixin from "@/utils/carteras";

export default {
  name: "AltaOperacion",
  components: {
    DatosDeudorOAcreedor,
    DatosOperacion,
    ResumenOperacion,
  },
  mixins: [RoutesMixin, StringsMixin, MessagesMixin, CarterasMixin],
  data() {
    return {
      entidadesAcreedor: [
        {
          tipo: "Particular",
          key: TIPOS_USUARIOS.USUARIO_TIPO_ACREEDOR_PARTICULAR,
          index: 1,
        },
        {
          tipo: "Autónomo",
          key: TIPOS_USUARIOS.USUARIO_TIPO_ACREEDOR_AUTONOMO,
          index: 2,
        },
        {
          tipo: "Persona jurídica u otro ente sin personalidad jurídica (Empresa, Instituto, ...)",
          key: TIPOS_USUARIOS.USUARIO_TIPO_ACREEDOR_ENTIDAD,
          index: 3,
        },
      ],
      entidadesDeudor: [
        {
          tipo: "Particular",
          key: TIPOS_USUARIOS.USUARIO_TIPO_DEUDOR_PARTICULAR,
          index: 1,
        },
        {
          tipo: "Autónomo",
          key: TIPOS_USUARIOS.USUARIO_TIPO_DEUDOR_AUTONOMO,
          index: 2,
        },
        {
          tipo: "Persona jurídica u otro ente sin personalidad jurídica (Empresa, Instituto, ...)",
          key: TIPOS_USUARIOS.USUARIO_TIPO_DEUDOR_ENTIDAD,
          index: 3,
        },
      ],
      stepNum: 1,
      steps: [
        { tag: "1", index: 1 },
        { tag: "2", index: 2 },
        { tag: "3", index: 3 },
        { tag: "4", index: 4 },
      ],

      addresses: [],
      defaultProvinces: [],
      defaultCountries: [],
      defaultLanguage: { key: "ES", language: "es" },
      operacion: {
        carteraUsuario: null,
        producto: null,
        origenDeuda: null,
        literalOrigenDeuda: null,
        ficherosMorosidad: [],
        procedimientoJudicial: false,
        fuente: "web_gran_cliente",
        referenciaCliente: null,
        datosAcreedor: {
          apellidos: "",
          codigoPostal: "",
          direccion: "",
          email: "",
          idLegal: null,
          localidad: "",
          nombre: "",
          pais: "ES",
          provincia: "",
          razonSocial: "",
          sectorActividad: "",
          codigoActividad: "",
          telefono: "",
          tipoEntidad: "",
          tipoSociedad: "",
          tipoVia: "",
        },
        datosDeudor: {
          apellidos: "",
          codigoPostal: "",
          direccion: "",
          email: "",
          idLegal: "",
          localidad: "",
          nombre: "",
          pais: "ES",
          provincia: "",
          razonSocial: "",
          sectorActividad: "",
          codigoActividad: "",
          telefono: "",
          tipoEntidad: "",
          tipoSociedad: "",
          tipoVia: "",
        },
        datosUsuario: {
          apellidos: "",
          nif: "",
          nombre: "",
          telefono: "",
          actuoEnPropioNombre: false,
        },
        impagos: [],
        jsonSegmento: "",
        idSegmento: ""
      },
      erroresAltaOperacion: [],
      loadingCTIAddressNormalization: false,
      loadingInsertOp: false,
      CTIAddressDialog: false,
    };
  },
  methods: {
    backward() {
      if (this.stepNum === 1) {
        this.goToListaExpedientesGrandesCuentas();
        return;
      } else if (this.stepNum === 2) {
        this.updateDireccionAcreedor();
      } else if (this.stepNum === 3 && this.skipCreditorStep()) {
        this.updateDireccionDeudor();
        this.stepNum -= 1;
      }
      if (this.stepNum !== 1)
        this.CTIAddressDialog = false; 
      this.stepNum -= 1;
      window.scrollTo(0, 0);
    },
    skipCreditorStep() {
      return (
        this.operacion.carteraUsuario.acreedorPorDefecto &&
        this.operacion.carteraUsuario.acreedorObligatorio
      );
    },
    updateDireccionAcreedor() {
      const ctiAddress = this.$refs.datosAcreedor.updateAddress();
      this.operacion.datosAcreedor.provincia = ctiAddress.province;
      this.operacion.datosAcreedor.localidad = ctiAddress.location;
      this.operacion.datosAcreedor.codigoPostal = ctiAddress.postalCode;
      this.operacion.datosAcreedor.tipoVia = ctiAddress.typeOfRoad;
      this.operacion.datosAcreedor.direccion = ctiAddress.address;
      this.operacion.datosAcreedor.pais = "ES";
    },
    updateDireccionDeudor() {
      const ctiAddress = this.$refs.datosDeudor.updateAddress();
      this.operacion.datosDeudor.provincia = ctiAddress.province;
      this.operacion.datosDeudor.localidad = ctiAddress.location;
      this.operacion.datosDeudor.codigoPostal = ctiAddress.postalCode;
      this.operacion.datosDeudor.tipoVia = ctiAddress.typeOfRoad;
      this.operacion.datosDeudor.direccion = ctiAddress.address;
      this.operacion.datosDeudor.pais = "ES";
    },
    resetDatosAcreedorOperacion() {
      this.resetDatosUsuarioOperacion("datosAcreedor");
    },
    resetDatosDeudorOperacion() {
      this.resetDatosUsuarioOperacion("datosDeudor");
    },
    resetDatosUsuarioOperacion(datosUsuario) {
      this.operacion[datosUsuario].apellidos = "";
      this.operacion[datosUsuario].codigoPostal = "";
      this.operacion[datosUsuario].direccion = "";
      this.operacion[datosUsuario].email = "";
      this.operacion[datosUsuario].idLegal = null;
      this.operacion[datosUsuario].localidad = "";
      this.operacion[datosUsuario].nombre = "";
      this.operacion[datosUsuario].pais = "ES";
      this.operacion[datosUsuario].provincia = "";
      this.operacion[datosUsuario].razonSocial = "";
      this.operacion[datosUsuario].sectorActividad = "";
      this.operacion[datosUsuario].codigoActividad = "";
      this.operacion[datosUsuario].telefono = "";
      this.operacion[datosUsuario].tipoEntidad = "";
      this.operacion[datosUsuario].tipoSociedad = "";
      this.operacion[datosUsuario].tipoVia = "";
    },
    getJsonSegmentoOperacion(){
    let json = this.$refs.datosOperacion.$refs.carteraUsuario.getJsonSegmento()
    if (json != null)
      this.operacion.jsonSegmento = json
    },  
    forward() {
      
      if (this.stepNum === 1) {
        this.getJsonSegmentoOperacion();
        this.$refs.datosOperacion.validateOperacion();
        if (this.$refs.datosOperacion.hasOperacionErrors()) {
          window.scrollTo(0, 0);
          return;
        }

        this.resetDatosAcreedorOperacion();
        this.resetDatosDeudorOperacion();

        if (this.operacion.carteraUsuario.acreedorPorDefecto) {
          this.$refs.datosAcreedor.searchCurrentUserData(
            this.operacion.carteraUsuario.acreedor.uuid
          );

          if (this.operacion.carteraUsuario.acreedorObligatorio)
            this.stepNum += 1;
        }

        this.stepNum += 1;
        window.scrollTo(0, 0);
        this.CTIAddressDialog = true;
      } else if (this.stepNum === 2) {
        this.updateDireccionAcreedor();
        this.$refs.datosAcreedor.validateForm();

        if (this.$refs.datosAcreedor.hasFormErrors()) {
          window.scrollTo(0, 0);
          return;
        }

        this.stepNum += 1;
        window.scrollTo(0, 0);
        this.CTIAddressDialog = true;
      } else if (this.stepNum === 3) {
        this.updateDireccionDeudor();
        this.$refs.datosDeudor.validateForm();

        if (this.$refs.datosDeudor.hasFormErrors()) {
          window.scrollTo(0, 0);
          return;
        }
        this.operacion.iban = null;
        this.stepNum += 1;
        window.scrollTo(0, 0);
      } else if (this.stepNum === 4) {
        this.$refs.resumenOperacion.validateOperacion();
        if (this.$refs.resumenOperacion.hasOperacionErrors()) {
          window.scrollTo(0, 0);
          return;
        }
        if (!this.loadingInsertOp)
          this.altaOperacion();
      }
    },
    operacionInput() {
      this.operacion.datosUsuario.uuid =
        this.operacion.carteraUsuario.usuarioCliente.uuid;
      this.operacion.datosUsuario.idLegal =
        this.operacion.carteraUsuario.usuarioCliente.idLegal;
      const fMorosidad = this.operacion.ficherosMorosidad.filter((f) => f);
      return {
        idLegalCliente: this.operacion.carteraUsuario.cliente.idLegal,
        acreedor: this.getUserData("datosAcreedor"),
        deudor: this.getUserData("datosDeudor"),
        usuario: this.getUserData("datosUsuario"),
        impagos: this.operacion.impagos,
        producto: this.operacion.producto.codigoProducto,
        tipoContrato: this.operacion.producto.contrato.tipo,
        divisa: "EUR",
        origen: this.operacion.origenDeuda,
        anexable: true,
        avisos: false,
        viaJudicial: this.operacion.procedimientoJudicial,
        viaJudicialFavorable: true,
        actuoEnPropioNombre:
          this.getUserData("datosUsuario").idLegal ==
          this.getUserData("datosAcreedor").idLegal,
        apiTransactionId: null,
        fuente: this.operacion.fuente,
        ibanAcreedor: this.operacion.carteraUsuario.iban
          ? this.operacion.carteraUsuario.iban.replaceAll(" ", "")
          : this.operacion.iban.replaceAll(" ", ""),
        referenciaCliente: null,
        referenciaClienteOperacion: this.operacion.referenciaCliente,
        ficherosDeudaIncluidos: fMorosidad,
        idCartera: this.operacion.carteraUsuario.id,
        lficherosAcreditacionDeuda: this.$refs.resumenOperacion.files,
        jsonSegmento: this.operacion.jsonSegmento,         
      };
      
    },
    getUserData(userType) {
      return {
        apellidos: this.operacion[userType].apellidos,
        cnae: this.operacion[userType].codigoActividad,
        codigoPostal: this.operacion[userType].codigoPostal,
        direccion: this.operacion[userType].direccion,
        email: this.operacion[userType].email,
        idLegal: this.operacion[userType].idLegal,
        localidad: this.operacion[userType].localidad,
        nombre: this.operacion[userType].nombre,
        pais: this.operacion[userType].pais,
        provincia: this.operacion[userType].provincia,
        razonSocial: this.operacion[userType].razonSocial,
        telefono: this.operacion[userType].telefono,
        tipo: this.getTipoUsuario(userType),
        tipoDireccion: this.operacion[userType].tipoVia,
        tipoSociedad: this.operacion[userType].tipoSociedad,
        uuid: this.operacion[userType].uuid,
      };
    },
    getTipoUsuario(userType) {
      if (this.operacion[userType].tipoEntidad !== undefined) {
        if (this.operacion[userType].tipoEntidad.key !== undefined) {
          return this.operacion[userType].tipoEntidad.key;
        }
        return this.operacion[userType].tipoEntidad;
      }
      return "";
    },
    altaOperacion() {
      this.loadingInsertOp=true;
      const operacionInput = this.operacionInput();
      this.$apollo
        .mutate({
          mutation: MUTATION_ALTA_RECLAMACION,
          variables: {
            input: operacionInput
          },
        })
        .then(() => {
          this.goToListaExpedientesGrandesCuentas();
        })
        .catch((error) => {
          window.scrollTo(0, 0);
          console.error(error);
          this.loadingInsertOp=false;
          this.erroresAltaOperacion = [];
          error.graphQLErrors.forEach((error) => {            
            if (error.message.includes('Cannot locate recovery method;')){
              let msgerrorCodes = ""
              msgerrorCodes = error.message.substring(error.message.indexOf("[")+1,(error.message.indexOf("]")));
              msgerrorCodes = msgerrorCodes.split(", ");
              msgerrorCodes.forEach(codeError => {
                this.erroresAltaOperacion.push(
                  this.$i18n.t("acciones.errores." + codeError)
                );
              });
              console.log(msgerrorCodes);
            } else {
              this.erroresAltaOperacion.push(
                this.$i18n.t("acciones.errores." + error.message)
              );
            }
            console.log(error.message);
          });
        });
    },
  },
  computed: {
    actOnOwnName() {
      return (
        this.operacion.datosAcreedor.idLegal &&
        this.operacion.carteraUsuario &&
        this.operacion.datosAcreedor.idLegal ==
          this.operacion.carteraUsuario.usuarioCliente.idLegal
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.verticalPadding {
  padding-top: 20px;
  padding-bottom: 2opx;
}

.bigBlueButton {
  margin-bottom: 40px;
  margin-top: 40px;
}

.openTopWhitePanel {
  background-color: white;
  padding: 10px 7% 20px 7%;
  margin-bottom: 20px;
  margin-top: -2.5cm;
  border-left: 1px solid #d0e1f2;
  border-right: 1px solid #d0e1f2;
  border-bottom: 1px solid #d0e1f2;
}

.marginTop {
  margin-top: 2em;
}
</style>
